import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Grid } from "@mui/material";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { SelectButton } from "primereact/selectbutton";
import {
  addRiskAssessment,
  updateRiskAssessment,
} from "../../service/riskAssessmentService";
import { Calendar } from "primereact/calendar";
import dayjs from "dayjs";
import {
  addRiskHazard,
  updateRiskHazard,
} from "../../service/riskHazardService";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import MultiDropdownApi from "../../components/MultiDropdownApi";

export default function RiskHazardAdd(modalProps: any) {
  const details = modalProps?.details;

  const client_id = modalProps?.client;
  const site = modalProps?.site;

  async function Add() {
    if (!!site) return;

    let updateDetails: any = {
      name,
      description,
      control_measure: controlMeasure,
    };
    modalProps.setGlobalLoading(true);
    if (modalProps.id) {
      updateRiskHazard(updateDetails, modalProps.id)
        .then((r: any) => {
          modalProps.toast.current.show({
            severity: "success",
            summary: "Hazard Updated Successfully",
            life: 3000,
          });
          modalProps.setVisible(false);
          modalProps.setGlobalLoading(false);
          modalProps.setReload(!modalProps.reload);
        })
        .catch((error) => {
          modalProps.toast.current.show({
            severity: "error",
            summary: "Failed to Updated Hazard",
            life: 3000,
          });
          modalProps.setGlobalLoading(false);
        });
    } else {
      if (client_id) {
        updateDetails.client_id = client_id;
      }
      addRiskHazard(updateDetails)
        .then((r: any) => {
          modalProps.toast.current.show({
            severity: "success",
            summary: "Hazard Created Successfully",
            life: 3000,
          });
          modalProps.setVisible(false);
          modalProps.setGlobalLoading(false);
          modalProps.setReload(!modalProps.reload);
        })
        .catch((error) => {
          modalProps.toast.current.show({
            severity: "error",
            summary: "Failed to Create Hazard",
            life: 3000,
          });
          modalProps.setGlobalLoading(false);
        });
    }
  }

  const [name, setName] = React.useState(details?.name || "");
  const [description, setDescription] = React.useState(
    details?.description || ""
  );
  const [activeStep, setActiveStep] = React.useState(0);

  const [controlMeasure, setControlMeasure] = React.useState(
    details?.control_measure || []
  );

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>
              Name<div style={{ color: "red" }}>*</div>
            </FormLabel>
            <FormControl
              sx={{
                display: { sm: "flex-column", md: "flex-row" },
                gap: 2,
              }}
            >
              <InputText
                value={name}
                readOnly={!!site}
                onChange={(e) => setName(e.target.value)}
                type="text"
                className="p-inputtext-sm PrimeSmallInput"
              />
            </FormControl>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Description</FormLabel>
            <FormControl
              sx={{
                display: { sm: "flex-column", md: "flex-row" },
                gap: 2,
              }}
            >
              <InputTextarea
                value={description}
                readOnly={!!site}
                placeholder="Description"
                onChange={(e) => setDescription(e.target.value)}
              />
            </FormControl>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <MultiDropdownApi
            apiPath="control-measure"
            optionLabel="name"
            optionValue="id"
            label="Control Measures"
            selectedData={controlMeasure}
            setSelectedData={setControlMeasure}
            disabled={!!site}
          />
        </Grid>
        <br />
      </Grid>

      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => Add()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
